import { UserProfile } from '../types/UserProfile'
import { SUserProfile } from '../types/api/UserProfile'

export const userProfileTransformer = (data: SUserProfile): UserProfile => {
  return {
    default: false,
    // users-permissions user relations use numeric FKs, not Content API documentId
    id: data.id != null ? String(data.id) : data.documentId ?? '',
    name: data.name ?? '',
    description: data.description ?? '',
    image: data.image ?? null,
    ...(data.canHaveSpecialty !== undefined && {
      canHaveSpecialty: data.canHaveSpecialty,
    }),
  } as UserProfile
}
